import React from 'react';
import { useTranslation } from 'react-i18next';
import IconModal from '@components/IconModal';
import { IconModalProps } from '@components/IconModal/IconModal';
import Crutches from '@images/crutches.png';
import Image from 'next/image';

const CoverageModal = (props: IconModalProps) => {
  const { t } = useTranslation();
  return (
    <IconModal
      {...props}
      icon={<Image src={Crutches} height={80} width={80} alt="crutches_icons" />}
    >
      <div className="flex flex-1 flex-col gap-4">
        <span className="font-bold heading/s leading-heading/s text-neutral/darkgrey/90">
          {t('coverage_modal.title')}
        </span>
        <span className="font-normal text-paragraph/s paragraph/s text-color/neutral/80">
          {t('coverage_modal.content')}
        </span>
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-paragraph/s paragraph/s text-color/neutral/80">
            {t('coverage_modal.subtitle')}
          </span>
          <span className="font-normal text-paragraph/s paragraph/s text-color/neutral/80">
            {t('coverage_modal.second_content')}
          </span>
        </div>
      </div>
    </IconModal>
  );
};

export default CoverageModal;
